<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <new :isSidebarActive="newSidebar" @closeSidebar="toggleNewSidebar" :data="sidebarData"/>
    <update :isSidebarActive="updateSidebar" @closeSidebar="toggleUpdateSidebar" :data="sidebarData"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="districts">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropdown -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">
            <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="editData(selected)">
                <span class="flex items-center">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Editar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="deleteData(selected)">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Eliminar</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- Add new -->
          <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary">Agregar</span>
          </div>
        </div>

        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{
                districts.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : districts.length
              }} de {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20"><span>20</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="sortOrder">Orden</vs-th>
        <vs-th sort-key="label">Nombre</vs-th>
        <vs-th sort-key="price">Precio (S/.)</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <p class="font-medium truncate">{{ tr.sortOrder }}</p>
          </vs-td>
          <vs-td>
            <p class="font-medium truncate">{{ tr.label }}</p>
          </vs-td>
          <vs-td>
            <p class="font-medium truncate">{{ tr.price }}</p>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="editData(tr)"/>
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current ml-2"
                          @click.stop="deleteData(tr)"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Update from './Update'

import { db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  components: {
    New,
    Update
  },
  data () {
    return {
      selected: null,
      itemsPerPage: 20,
      isMounted: false,
      initProgress: false,

      // Data Sidebar
      newSidebar: false,
      updateSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    districts () {
      return this.$store.state.districts.districts
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.districts.length
    }
  },
  async created () {
    try {
      this.initProgress = true
      const snap = await db.collection('districts').orderBy('sortOrder').get()
      const list = []
      snap.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() })
      })
      await this.$store.dispatch('districts/fetchDistricts', { districts: list })
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error al cargar los distritos.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.newSidebar = true
    },
    editData (data) {
      if (data) {
        this.sidebarData = data
        this.toggleUpdateSidebar(true)
      }
    },
    async deleteData (data) {
      if (!data) return
      try {
        await this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirmar',
          text: `¿Deseas eliminar el distrito "${data.label}"?`,
          accept: async () => {
            await db.collection('districts').doc(data.id).delete()
            await this.$store.dispatch('districts/removeDistrict', { id: data.id })
            this.$vs.notify({
              color: 'success',
              title: 'Distrito',
              text: 'Distrito eliminado correctamente.'
            })
          }
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    toggleNewSidebar (val = false) {
      this.newSidebar = val
    },
    toggleUpdateSidebar (val = false) {
      this.updateSidebar = val
    },
    /**
     * Sync districts to Firebase: creates missing ones, updates sortOrder on existing.
     */
    async syncInitialData () {
      const initialDistricts = [
        { label: 'INDEPENDENCIA', price: 7.9 },
        { label: 'SAN MARTIN DE PORRES', price: 7.9 },
        { label: 'SMP', price: 7.9 },
        { label: 'LOS OLIVOS', price: 7.9 },
        { label: 'COMAS', price: 10 },
        { label: 'LA PERLA', price: 7.9 },
        { label: 'BELLAVISTA', price: 7.9 },
        { label: 'CARMEN DE LA LEGUA', price: 7.9 },
        { label: 'BOCA NEGRA', price: 7.9 },
        { label: 'CALLAO', price: 10 },
        { label: 'SAN ISIDRO', price: 7.9 },
        { label: 'MIRAFLORES', price: 7.9 },
        { label: 'SAN BORJA', price: 7.9 },
        { label: 'SURCO', price: 7.9 },
        { label: 'SANTIAGO DE SURCO', price: 7.9 },
        { label: 'SURQUILLO', price: 7.9 },
        { label: 'BARRANCO', price: 7.9 },
        { label: 'CHORRILLOS', price: 10 },
        { label: 'SAN JUAN DE MIRAFLORES', price: 10 },
        { label: 'SJM', price: 7.9 },
        { label: 'LIMA', price: 7.9 },
        { label: 'SAN MIGUEL', price: 7.9 },
        { label: 'MAGDALENA DEL MAR', price: 7.9 },
        { label: 'MAGDALENA', price: 7.9 },
        { label: 'BREÑA', price: 7.9 },
        { label: 'LINCE', price: 7.9 },
        { label: 'PUEBLO LIBRE', price: 7.9 },
        { label: 'CERCADO DE LIMA', price: 7.9 },
        { label: 'CERCADO', price: 7.9 },
        { label: 'RIMAC', price: 7.9 },
        { label: 'JESUS MARIA', price: 7.9 },
        { label: 'AGENCIA DE TRANSPORTE', price: 7.9 },
        { label: 'LA VICTORIA', price: 7.9 },
        { label: 'LA MOLINA', price: 10 },
        { label: 'SANTA ANITA', price: 7.9 },
        { label: 'ATE', price: 10 },
        { label: 'SAN JUAN DE LURIGANCHO', price: 10 },
        { label: 'SJL', price: 7.9 },
        { label: 'EL AGUSTINO', price: 7.9 },
        { label: 'SAN LUIS', price: 7.9 },
        { label: 'CAMPOY', price: 7.9 },
        { label: 'SAN JUAN DE LURIGANCHO 2', price: 10 },
        { label: 'SJL 2', price: 11.9 },
        { label: 'COLLIQUE', price: 10 },
        { label: 'LA PUNTA', price: 10 },
        { label: 'CARABAYLLO', price: 11.9 },
        { label: 'PUENTE PIEDRA', price: 11.9 },
        { label: 'SANTA CLARA', price: 10 },
        { label: 'HUACHIPA', price: 14.9 },
        { label: 'JICAMARCA', price: 14.9 },
        { label: 'LA PLANICIE', price: 10 },
        { label: 'PAMPLONA ALTA', price: 11.9 },
        { label: 'PANTANOS DE VILLA', price: 11.9 },
        { label: 'VILLA EL SALVADOR', price: 11.9 },
        { label: 'VES', price: 11.9 },
        { label: 'VILLA MARIA DEL TRIUNFO', price: 11.9 },
        { label: 'VMT', price: 11.9 },
        { label: 'SAN JUAN DE MIRAFLORES 2', price: 11.9 },
        { label: 'LURIGANCHO CHOSICA', price: 14.9 },
        { label: 'SAN GABRIEL ALTO', price: 14.9 },
        { label: 'MUSA', price: 14.9 },
        { label: 'VENTANILLA', price: 14.9 },
        { label: 'JOSE GALVEZ', price: 14.9 },
        { label: 'LURIGANCHO CHOSICA 2', price: 24.9 },
        { label: 'MARQUEZ', price: 14.9 },
        { label: 'CARABAYLLO 2', price: 14.9 },
        { label: 'PUENTE PIEDRA 2', price: 14.9 },
        { label: 'PUENTE PIEDRA 3', price: 19.9 },
        { label: 'CHACLACAYO', price: 24.9 },
        { label: 'HUAYCAN', price: 14.9 },
        { label: 'HUAYCAN 2', price: 19.9 },
        { label: 'MI PERU', price: 19.9 },
        { label: 'PACHACUTEC', price: 24.9 },
        { label: 'ÑAÑA', price: 24.9 }
      ]

      try {
        this.initProgress = true

        // Fetch all existing documents and build a label → ref map
        const snap = await db.collection('districts').get()
        const existingByLabel = {}
        snap.forEach((doc) => {
          existingByLabel[doc.data().label] = doc.ref
        })

        const batch = db.batch()
        initialDistricts.forEach((district, index) => {
          const sortOrder = index + 1
          const existing = existingByLabel[district.label]
          if (existing) {
            // Update sortOrder on existing document
            batch.update(existing, { sortOrder })
          } else {
            // Create new document
            const ref = db.collection('districts').doc()
            batch.set(ref, {
              ...district,
              sortOrder,
              state: true,
              createdAt: FieldValue.serverTimestamp()
            })
          }
        })
        await batch.commit()

        // Reload ordered by sortOrder
        const freshSnap = await db.collection('districts').orderBy('sortOrder').get()
        const list = []
        freshSnap.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() })
        })
        await this.$store.dispatch('districts/fetchDistricts', { districts: list })

        this.$vs.notify({
          color: 'success',
          title: 'Distritos',
          text: 'Orden sincronizado correctamente en Firebase.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error al sincronizar.'
        })
      } finally {
        this.initProgress = false
      }
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
